<template>
    <aside-block v-if="question">
        <template slot="header">Задание №{{progress.current}} из {{progress.length}}</template>

        <template slot="default">
            <div class="aside-question">
                {{question.text}}
            </div>
            <div class="aside-question-sub">
                {{question.info}}
            </div>

            <div class="aside-answer">
                <question-radio
                        dark
                        @input="onUpdateAnswer"
                        v-if="question.type === 'radio'"
                        :items="question.answers"
                        :id="question.id"
                        :isHidden="question.hidden_answers"
                />
                <question-checkbox
                        dark
                        v-if="question.type === 'checkbox'"
                        :items="question.answers"
                        :id="question.id"
                        @input="onUpdateAnswer"
                        :isHidden="question.hidden_answers"
                />
                <question-input
                        dark
                        v-if="question.type === 'input'"
                        :id="question.id"
                        :isHidden="question.hidden_answers"
                        @input="onUpdateAnswer"
                />
                <question-select-text
                        v-if="question.type === 'selected_text'"
                        :value="answer"
                        @input="onUpdateAnswer"
                        :isHidden="question.hidden_answers"
                        :id="question.id"
                />
            </div>
        </template>

        <template slot="footer">
            <div class="s-footer">
                <!--<span class="help-btn" @click="help = true"></span>-->
                <v-btn color="success" @click="onContinue" :loading="pending">Следующее задание<v-icon>chevron_right</v-icon></v-btn>
            </div>
        </template>

        <v-dialog v-model="help" scrollable max-width="900px">
            <v-card>
                <v-card-title>Помощь</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 100%;">
                    <block-help></block-help>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" flat @click.native="help = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </aside-block>
</template>

<script>
    import AsideBlock from '@/views/session/aside.vue'
    import QuestionRadio from '@/components/question/radio'
    import QuestionInput from '@/components/question/input'
    import QuestionCheckbox from '@/components/question/checkbox'
    import QuestionSelectText from '@/components/question/select-text'
    import BlockHelp from './help'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                help: false,
                dialog: false,
                pending: false
            }
        },
        components: {
            AsideBlock,
            QuestionRadio,
            QuestionInput,
            QuestionCheckbox,
            QuestionSelectText,
            BlockHelp
        },
        computed: {
            ...mapGetters('questions', ['question', 'progress', 'answer'])
        },
        methods: {
            onContinue () {
                if (this.pending) return

                let answer = undefined
                if (this.question.type === 'selected_text' && this.answer) {
                    answer = this.answer.map(({text}) => {
                        return text
                    })
                }
                this.pending = true
                this.$store.dispatch('questions/sendAnswer', answer)
                    .then(() => this.pending = false)
                    .catch(() => this.pending = false)
            },
            onUpdateAnswer (value) {
                this.$store.dispatch('questions/answer', value)
            }
        }
    }
</script>
<style lang="stylus" scoped>
    .aside-question {
        font-size 1.3rem
        color #e0e0e0
        margin-bottom 15px
    }
    .aside-question-sub {
        font-size 1.2rem
        line-height 1.2
        color #8a8a8a
        margin-bottom 15px
    }
    .aside-task {
        padding-top 10px

        &__title {
            font-weight bold
            display block
            color #8a8a8a
        }
    }
    .help-btn {
        cursor pointer
        display block
        height 50px
        width 50px
        background no-repeat center center/25px auto url(../../../../public/images/question-icon.svg)
    }
    .s-footer {
        display flex
        align-items center
        margin-left -0.5rem
        .btn {
            flex 1 1
        }
    }
</style>
